<template>
	<main>
		<section class="container ly_mw-68 ly_col-24">
			<ResponsiveLayout class="ly_responsive">
				<SectorMainTitle />
			</ResponsiveLayout>
			<StickyHideTabBar
				v-if="etfTabListData && etfTabListData?.etf_tab_list.length > 0"
				:items="['전체 ', ...etfTabListData?.etf_tab_list]"
				@update:category="onSelectHotRankingTab"
			/>
			<MoreListLayout v-if="etfData && etfData?.etf_count > 0" class="c_responsive">
				<ListLayout class="list_layout">
					<SectorRankList
						:data="etfData?.etf"
						@update:book-mark-refetch="handleClickBookmark"
						@update:research="handleClickResearch"
					/>
				</ListLayout>
				<MoreButton
					v-if="etfData?.etf.length < (etfData?.etf_count ?? 0)"
					:disabled="isFetchingNextPage"
					@click="onClickBestIncrease"
				/>
			</MoreListLayout>
		</section>
	</main>
</template>

<script setup lang="ts">
// core
import { computed } from 'vue';
import { useRoute } from 'vue-router';
// lib
import { useQueryClient } from '@tanstack/vue-query';

// api
import { useGeEtfTabListApi, useGetEtfInfiniteApi } from '@/api/etf';
// component
import MoreButton from '@/components/atom/button/MoreButton.vue';
import StickyHideTabBar from '@/components/atom/tabBar/StickyHideTabBar.vue';
import SectorMainTitle from '@/components/etf/SectorMainTitle.vue';
import SectorRankList from '@/components/etf/SectorRankList.vue';
import ListLayout from '@/components/layout/main/ListLayout.vue';
import MoreListLayout from '@/components/layout/main/MoreListLayout.vue';
import ResponsiveLayout from '@/components/layout/main/ResponsiveLayout.vue';

// -----variable-----
const route = useRoute();
const queryClient = useQueryClient();

const category = computed(() => String(route.params.category));
const selectTab = computed(() => String(route.query.tab || '전체'));

// -----api-----
const { data: etfTabListData } = useGeEtfTabListApi(
	computed(() => ({
		category: String(category.value),
	}))
);

const {
	data: etfData,
	fetchNextPage,
	isFetchingNextPage,
	refetch: refetchEtfData,
} = useGetEtfInfiniteApi(
	computed(() => ({
		category: String(category.value),
		tab: selectTab.value,
	}))
);

// -----function-----
// 더보기 클릭 시 실행 함수
const onClickBestIncrease = async () => {
	await fetchNextPage();
};
// 즐겨찾기 클릭 시 실행 함수
const handleClickBookmark = async () => {
	await refetchEtfData();
};
// 리서치 클릭 시 실행 함수
const handleClickResearch = async () => {
	const apiUrl = '/v1/front/usa/getEtf';
	queryClient.removeQueries({
		queryKey: [apiUrl, { category: String(category.value) ?? '', tab: selectTab.value ?? '' }],
	});
};
// 핫랭킹 탭 클릭 시 실행 함수
const onSelectHotRankingTab = async () => {
	const apiUrl = '/v1/front/usa/getEtf';
	queryClient.removeQueries({
		queryKey: [apiUrl, { category: String(category.value) ?? '', tab: selectTab.value ?? '' }],
	});
};
</script>

<style lang="scss" scoped>
.ly_responsive {
	margin-bottom: 2.4rem;
}
</style>
